import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { appLanguage, theme } from '../../../../_constants/appSetting.constant';
import { LOCALSTORAGEKEYS } from '../../../../_constants/localStorageKeys';
import { IAppLanguage } from '../../../../_models/appSetting.model';
import { AppSettingService } from '../../../../_services/_appSetting/app-setting.service';
import { LocalService } from '../../../../_services/_storage/local.service';

@Component({
    selector: 'lokos-global-header',
    templateUrl: './global-header.component.html',
    styleUrl: './global-header.component.scss',
    standalone: false,
})
export class GlobalHeaderComponent implements OnInit {
    appLanguages: IAppLanguage[] = appLanguage;
    defaultFontSize = 12;
    activeButton: 'decrease' | 'reset' | 'increase' = 'reset';
    fontSize = 'a';
    selectedLanguage = appLanguage[0];
    theme!: string;

    constructor(
        private appSetting: AppSettingService,
        private localService: LocalService,
        private transalate: TranslateService
    ) {}

    ngOnInit(): void {
        this.loadSavedLanguage();
        this.getUserSystemTheme();
    }

    loadSavedLanguage() {
        const savedLang = this.localService.get(
            LOCALSTORAGEKEYS.SELECTED_LANGUAGE
        );
        if (savedLang) {
            const lang = JSON.parse(savedLang);

            this.selectedLanguage = lang;
            this.transalate.use(lang.langCode);
        } else {
            this.transalate.use(this.selectedLanguage.langCode);
        }
    }

    getUserSystemTheme() {
        if (localStorage.getItem('theme')) {
            this.setTheme(localStorage.getItem('theme') || '');
        } else {
            if (
                window.matchMedia &&
                window.matchMedia('(prefers-color-scheme: dark)').matches
            ) {
                this.setTheme(theme.DARK);
            } else {
                this.setTheme(theme.LIGHT);
            }
        }
        window
            .matchMedia('(prefers-color-scheme: dark)')
            .addEventListener('change', (event) => {
                const systemTheme = event.matches ? theme.DARK : theme.LIGHT;
                this.setTheme(systemTheme);
            });
    }

    setTheme(theme: string) {
        this.theme = theme;
        const htmlRoot: HTMLElement = document.getElementsByTagName(
            'body'
        )[0] as HTMLElement;
        if (htmlRoot != null) {
            htmlRoot.setAttribute('data-theme', theme);
        }
        localStorage.setItem('theme', theme);
        this.appSetting.appTheme$.next(theme);
    }

    onLanguageChange(lang: IAppLanguage) {
        this.selectedLanguage = lang;
        this.transalate.use(lang.langCode);
        this.localService.set(LOCALSTORAGEKEYS.SELECTED_LANGUAGE, lang);
    }

    changeFontSize(action: 'decrease' | 'reset' | 'increase') {
        if (action === 'reset') {
            this.defaultFontSize = 12;
        } else if (action === 'decrease' && this.defaultFontSize > 10) {
            this.defaultFontSize -= 1;
        } else if (action === 'increase' && this.defaultFontSize < 14) {
            this.defaultFontSize += 1;
        }

        this.activeButton = action;
        const htmlRoot: HTMLElement = document.getElementsByTagName(
            'html'
        )[0] as HTMLElement;
        if (htmlRoot != null) {
            htmlRoot.style.fontSize = `${this.defaultFontSize}px`;
        }
    }
}
